<template>
    <div class="card-body btm-pad">
        <hr />
        <div class="row">
            <div class="col-md-6 upgrade-title">
                <p>Data Package / Speed</p>
                <span class="fa fa-database" style="color: orange"></span>
                <span class="fa fa-bolt" style="color: yellow"></span>
            </div>
        </div>
        <div class="row row-spacing">
             <div class="col-md-6">
                 <div v-if="saleDefinition.definition.uncappedService">
                     <div class="form-group">
                         <label>Select Uncapped Package</label>
                         <multiselect
                            v-model="selectedUncappedConnectivityPackage"
                            :options="sortedUncappedConnectivityPackages"
                            label="description"
                            track-by="connectivityPackageNumber"
                            placeholder="Select"
                            open-direction="auto"
                         ></multiselect>
                     </div>
                 </div>
                 
                 <div v-if="saleDefinition.definition.internetAccess">
                     <div class="form-group">
                         <label>Select Internet Package</label>
                         <multiselect
                            v-model="selectedInternetConnectivityPackage"
                            :options="sortedInternetConnectivityPackages"
                            label="description"
                            track-by="connectivityPackageNumber"
                            placeholder="Select"
                            open-direction="auto"
                         ></multiselect>
                     </div>
                 </div>
                 <button class="btn btn-success" @click="confirmPackageChange()">Change Package</button>
             </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            saleNumber: null,
            shapedPools: [],
            saleDefinition: {
                definition: {
                    uncappedService: {},
                    internetAccess: {},
                },
                product: {},
                selectableOptions: {
                    connectivityPackage: [],
                    internetConnectivityPackage: []
                },
            },
            regradeProducts: [],
            availableProducts: [],
            selectedUncappedConnectivityPackage: null,
            selectedInternetConnectivityPackage: null
        }
    },
    mounted() {
        this.saleNumber = this.$route.params.saleNumber;
        this.getShapedPools();
        this.loadSaleDefinition();
    },
    watch: {
        selectedUncappedConnectivityPackage(pkg) {
            if (!this.saleDefinition?.definition?.uncappedService) return;
            this.saleDefinition.definition.uncappedService.connectivityPackageNumber = pkg ? pkg.connectivityPackageNumber : null;
        },

        selectedInternetConnectivityPackage(pkg) {
            if (!this.saleDefinition?.definition?.internetAccess) return;
            this.saleDefinition.definition.internetAccess.connectivityPackageNumber = pkg ? pkg.connectivityPackageNumber : null;
        }
    },
    computed: {
        sortedInternetConnectivityPackages() {
            const pkgs = this.saleDefinition?.selectableOptions?.internetConnectivityPackage;
            if (!Array.isArray(pkgs)) return [];

            return pkgs
            .filter(pkg => !pkg.expired)
            .slice()
            .sort(this.sortConnectivityPackages);
        },

        sortedUncappedConnectivityPackages() {
            const pkgs = this.saleDefinition?.selectableOptions?.connectivityPackage;
            if (!Array.isArray(pkgs)) return [];

            return pkgs
            .filter(pkg => !pkg.expired)
            .slice()
            .sort(this.sortConnectivityPackages);
        }
    },
    methods: {
        getShapedPools: function() {
            const hostUrl = this.$config.aimsAPI;
            this.$http.get(`${hostUrl}shapedpools`).then(
                (response) => {
                    this.shapedPools = response.body;
                },
                (error) => {
                    this.showError("Error fetching Shaped Pools", error)
                    console.error(error);
                }
            );
        },

        loadSaleDefinition: function() {
            const hostUrl = this.$config.aimsAPI;
            this.$http.get(`${hostUrl}sales/definition/sale/${this.saleNumber}`).then(
                (response) => {
                    this.saleDefinition = response.data;
                },
                (error) => {
                    console.error(error);
                    this.showError("Error loading Sale Definition", error);
                }
            );
        },

        confirmPackageChange: function() {
            this.$swal({
                title: "Are you sure you want to a different Package?",
                text: "The billing will change for this client",
                type: "warning",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes",
            }).then((result) => {
                if (result.value) {
                    this.changePackage();
                }
            });
        },

        changePackage: function() {
            if (this.saleDefinition.definition.uncappedService) {
                const hostUrl = this.$config.aimsAPI;
                const saleNumber = this.$route.params.saleNumber;
                const uncappedServiceObj = this.saleDefinition.definition.uncappedService;
                this.$http.put(`${hostUrl}sales/definition/${saleNumber}/obj/update`, uncappedServiceObj).then(
                    (response) => {
                        this.showSuccess("Successfully changed Package");
                    },
                    (error) => {
                        console.error(error);
                        this.showError("Error Changing Package", error);
                    }
                )
            } else if (this.saleDefinition.definition.internetAccess) {
                const hostUrl = this.$config.aimsAPI;
                const saleNumber = this.$route.params.saleNumber;
                const internetAccessServiceObj = this.saleDefinition.definition.internetAccess;
                this.$http.put(`${hostUrl}sales/definition/${saleNumber}/obj/update`, internetAccessServiceObj).then(
                    (response) => {
                        this.showSuccess("Successfully changed Package");
                    },
                    (error) => {
                        console.error(error);
                        this.showError("Error Changing Package", error);
                    }
                )
            }
        },
        safeString(val) {
            return (val ?? "").toString().toLowerCase();
        },

        extractYears(term) {
            const match = term?.match(/\d+/);
            return match ? parseInt(match[0], 10) : Number.MAX_SAFE_INTEGER;
        },

        sortConnectivityPackages(a, b) {
            const speedA = a.downloadSpeed ?? 0;
            const speedB = b.downloadSpeed ?? 0;
            if (speedA !== speedB) {
                return speedA - speedB;
            }

            const termA = this.extractYears(a.contractTerm);
            const termB = this.extractYears(b.contractTerm);
            if (termA !== termB) {
                return termA - termB;
            }

            const labelA = this.safeString(a.label);
            const labelB = this.safeString(b.label);

            if (!labelA && labelB) return 1;
            if (labelA && !labelB) return -1;

            return labelA.localeCompare(labelB);
        },
    },
    
}
</script>

<style lang="scss" scoped>
.upgrade-title {
  font-size: 22px;
  text-align: center;
  padding: 5px;
}

.btm-pad {
    padding-bottom: 12em;
}
</style>
